import classnames from 'classnames';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

import { pageSelector } from '@/core/core.selectors';

import styles from './ProductsLayout.module.scss';

interface Props extends PropsWithChildren {
  className?: string;
  withPromoted?: boolean;
  dataTestId?: string;
  hideProductsLayout?: boolean;
  newLayoutDisabled?: boolean;
  presentation?: 'technical' | 'inspirational';
}

export const ProductsLayout: FunctionComponent<Props> = ({
  className,
  withPromoted = false,
  dataTestId,
  children,
  hideProductsLayout = false,
  newLayoutDisabled = false,
  presentation = 'technical',
}) => {
  const { pageName = '', pageType = '' } = useSelector(pageSelector) ?? {};
  const rootClassnames = classnames(styles.root, className, {
    [styles.hasPromoted]: withPromoted,
    [styles.hidden]: hideProductsLayout,
    [styles.technical]: !newLayoutDisabled && presentation === 'technical',
    [styles.inspirational]:
      !newLayoutDisabled && presentation === 'inspirational',
  });

  return (
    <div
      key={`${pageType}-${pageName}`}
      className={rootClassnames}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

ProductsLayout.displayName = 'ProductsLayout';
